import { render, staticRenderFns } from "./password-change.vue?vue&type=template&id=d3e2eb50&"
import script from "./password-change.vue?vue&type=script&lang=js&"
export * from "./password-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports